import API from '../api/api';
import Constants from './constants';
export default class Statistics {
    static async init() {
        if (!Constants.UserMetadata)
            return;
        const date = new Date();
        this.currentDay = Number(new Date(date.getFullYear(), date.getMonth(), date.getDate()));
        const data = await this.get();
        if (!(data === null || data === void 0 ? void 0 : data.optional.startDate))
            this.startDate = this.currentDay;
        if (data) {
            this.learnedWords = data.learnedWords;
            this.sprintStreakPerDay = data.optional.sprintStreakPerDay;
            this.audioStreakPerDay = data.optional.audioStreakPerDay;
            this.newWordsPerDay = data.optional.newWordsPerDay;
            this.learnedWordsPerDay = data.optional.learnedWordsPerDay;
            this.learnedWordsList = data.optional.learnedWordsList;
            this.seenWordsList = data.optional.seenWordsList;
        }
        this.update();
    }
    static async get() {
        if (!Constants.UserMetadata)
            return undefined;
        const statisticsData = await API.statistics.get(Constants.UserMetadata.userId);
        const statistics = statisticsData
            ? {
                learnedWords: this.learnedWords,
                optional: {
                    startDate: statisticsData.optional.startDate,
                    sprintStreakPerDay: statisticsData.optional.sprintStreakPerDay,
                    audioStreakPerDay: statisticsData.optional.audioStreakPerDay,
                    newWordsPerDay: statisticsData.optional.newWordsPerDay,
                    learnedWordsPerDay: statisticsData.optional.learnedWordsPerDay,
                    seenWordsList: statisticsData.optional.seenWordsList || [],
                    learnedWordsList: statisticsData.optional.learnedWordsList || [],
                },
            }
            : {
                learnedWords: this.learnedWords,
                optional: {
                    startDate: this.startDate,
                    sprintStreakPerDay: [{ date: this.currentDay, streak: 0 }],
                    audioStreakPerDay: [{ date: this.currentDay, streak: 0 }],
                    newWordsPerDay: [{ date: this.currentDay, words: 0 }],
                    learnedWordsPerDay: [{ date: this.currentDay, words: 0 }],
                    learnedWordsList: [],
                    seenWordsList: [],
                },
            };
        return statistics;
    }
    static async updadeGameStats(game, isWin) {
        if (game === 'sprint') {
            if (this.currentDay === this.sprintStreakPerDay[this.sprintStreakPerDay.length - 1].date)
                this.sprintStreakPerDay[this.sprintStreakPerDay.length - 1].streak =
                    this.sprintStreakPerDay[this.sprintStreakPerDay.length - 1].streak * Number(isWin) +
                        Number(isWin);
            else
                this.sprintStreakPerDay.push({ date: this.currentDay, streak: Number(isWin) });
        }
        else if (game === 'audio') {
            if (this.currentDay === this.audioStreakPerDay[this.audioStreakPerDay.length - 1].date)
                this.audioStreakPerDay[this.audioStreakPerDay.length - 1].streak +=
                    this.audioStreakPerDay[this.audioStreakPerDay.length - 1].streak * Number(isWin) +
                        Number(isWin);
            else
                this.audioStreakPerDay.push({ date: this.currentDay, streak: Number(isWin) });
        }
        this.update();
    }
    static add(wordId, list) {
        const lastLearnedLength = this.learnedWordsList.length;
        const lastNewWordsLength = this.seenWordsList.length;
        if (list === 'learned' && !this.learnedWordsList.includes(wordId)) {
            this.learnedWords += 1;
            this.learnedWordsList.push(wordId);
            if (!this.learnedWordsPerDay.find((word) => word.date === this.currentDay))
                this.learnedWordsPerDay.push({ date: this.currentDay, words: 0 });
            this.learnedWordsPerDay[this.learnedWordsPerDay.findIndex((word) => word.date === this.currentDay)].words += this.learnedWordsList.length - lastLearnedLength;
        }
        else if (list === 'seen' && !this.seenWordsList.includes(wordId)) {
            this.seenWordsList.push(wordId);
            if (!this.newWordsPerDay.find((word) => word.date === this.currentDay))
                this.newWordsPerDay.push({ date: this.currentDay, words: 0 });
            this.newWordsPerDay[this.newWordsPerDay.findIndex((word) => word.date === this.currentDay)].words += this.seenWordsList.length - lastNewWordsLength;
        }
        this.update();
    }
    static remove(wordId, list) {
        const lastLearnedLength = this.learnedWordsList.length;
        const lastNewWordsLength = this.seenWordsList.length;
        if (list === 'learned' && this.learnedWordsList.includes(wordId)) {
            this.learnedWords = 0;
            this.learnedWordsList = this.learnedWordsList.filter((el) => el !== wordId);
            if (!this.learnedWordsPerDay.find((word) => word.date === this.currentDay))
                this.learnedWordsPerDay.push({ date: this.currentDay, words: 0 });
            this.learnedWordsPerDay[this.learnedWordsPerDay.findIndex((word) => word.date === this.currentDay)].words += this.learnedWordsList.length - lastLearnedLength;
        }
        else if (list === 'seen' && this.seenWordsList.includes(wordId)) {
            this.learnedWordsList = this.learnedWordsList.filter((el) => el !== wordId);
            if (!this.newWordsPerDay.find((word) => word.date === this.currentDay))
                this.newWordsPerDay.push({ date: this.currentDay, words: 0 });
            this.newWordsPerDay[this.newWordsPerDay.findIndex((word) => word.date === this.currentDay)].words += this.seenWordsList.length - lastNewWordsLength;
        }
        this.update();
    }
    static async update() {
        if (!Constants.UserMetadata)
            return;
        const statisticsData = await this.get();
        if (statisticsData) {
            statisticsData.learnedWords = this.learnedWords;
            statisticsData.optional.startDate = this.startDate;
            statisticsData.optional.sprintStreakPerDay = this.sprintStreakPerDay;
            statisticsData.optional.audioStreakPerDay = this.audioStreakPerDay;
            statisticsData.optional.newWordsPerDay = this.newWordsPerDay;
            statisticsData.optional.learnedWordsPerDay = this.learnedWordsPerDay;
            statisticsData.optional.learnedWordsList = this.learnedWordsList;
            statisticsData.optional.seenWordsList = this.seenWordsList;
            API.statistics.update(Constants.UserMetadata.userId, statisticsData);
        }
    }
}
Statistics.learnedWords = 0;
